<template>
  <a-card class="method-card card">
    <div slot="title" class="card-title text-center">
      {{ $t('PAYMENT_STEP_SELECT_METHOD') }}
    </div>
    <a-alert
      show-icon
      type="info"
      class="invoice-alert"
    >
      <a-icon slot="icon" type="file-text" />
      <div slot="description" class="invoice-note-wrapper">
        <span v-html="$t('PAYMENT_INVOICE_NOTE')" />
        <a
          href="javascript:void(0)"
          class="invoice-zalo-link"
          @click="openInvoiceModal"
        >
          {{ $t('PAYMENT_INVOICE_CONTACT_ZALO') }}
        </a>
      </div>
    </a-alert>
    <a-radio-group
      :value="paymentMethodId"
      class="method-radio-group"
      @change="handleMethodChange"
    >
      <a-row>
        <a-col>
          <a-list
            item-layout="horizontal"
            :data-source="option.method"
            class="method-list"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="method-item hand-mouse"
              :class="{ 'method-item-selected': item.id === paymentMethodId }"
              @click="handleMethodClick(item)"
            >
              <a-list-item-meta>
                <div slot="title" class="method-title">
                  <a-radio :value="item.id" class="method-radio">
                    {{ item.name }}
                  </a-radio>
                </div>
                <div slot="description" class="method-details">
                  <div class="method-logo-container">
                    <img
                      :src="item.logo"
                      class="method-logo"
                    >
                  </div>
                  <div class="method-info">
                    <p class="method-id">
                      <strong>{{ item._id }}</strong>
                    </p>
                    <p class="method-owner">{{ item.owner }}</p>
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-radio-group>
  </a-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'MethodStep',
  props: {
    paymentMethodId: {
      type: [String, Number],
      default: '',
    },
    option: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('ui', ['openInvoiceModal']),
    handleMethodChange(e) {
      this.$emit('method-change', e.target.value);
    },
    handleMethodClick(item) {
      this.$emit('method-click', item);
    },
  },
};
</script>

<style scoped>
.method-card {
  margin-top: var(--spacing-md);
}

.invoice-alert {
  width: 100%;
  border-radius: var(--border-radius-md);
  margin-bottom: var(--spacing-md);
}

.invoice-note-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.invoice-zalo-link {
  font-weight: var(--font-weight-medium);
  text-decoration: underline;
  white-space: nowrap;
}

.method-radio-group {
  width: 100%;
}

.method-list {
  background: transparent;
}

.method-item {
  padding: var(--spacing-md) !important;
  border-radius: var(--border-radius-lg);
  margin-bottom: var(--spacing-sm);
  border: 1px solid var(--border-color);
  transition: border-color var(--transition-base), background-color var(--transition-base);
  background: var(--bg-primary);
  text-align: center;
  touch-action: manipulation;
}

@media (max-width: 768px) {
  .method-item {
    padding: var(--spacing-lg) var(--spacing-md) !important;
    min-height: 44px;
  }
}

.method-item:hover {
  border-color: var(--primary-color);
}

.method-item.method-item-selected {
  border-color: var(--primary-color);
  background: var(--primary-subtle);
  box-shadow: 0 0 0 1px var(--primary-color);
}

.method-title {
  margin-bottom: var(--spacing-md);
}

.method-radio {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}

.method-details {
  margin-top: var(--spacing-sm);
}

.method-logo-container {
  margin-bottom: var(--spacing-sm);
}

.method-logo {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.method-info {
  margin-top: var(--spacing-sm);
}

.method-id {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin-bottom: var(--spacing-xs);
}

.method-owner {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  margin: 0;
}

.hand-mouse {
  cursor: pointer;
}
</style>
